import React from 'react';
import { StackedIcon } from 'ui/StackedIcon';
import SquareIcon from 'ui/Icons/tabler/square.component.svg';
import MinusIcon from 'ui/Icons/tabler/minus.component.svg';

export const NegativeIcon = (
  <StackedIcon
    BackgroundIcon={SquareIcon}
    ForegroundIcon={MinusIcon}
    backgroundClassName="w-8 h-8 fill-red-40"
    foregroundClassName="w-4 h-4 fill-transparent stroke-black stroke-2"
    stackDirection="overlay"
  />
);
